module.exports = __webpack_public_path__ + "img/user.79271260.svg";